import store from '@/states/index.js'

import SupplierComponent from '../SupplierComponent'

export default [
    {
        path: '/supplier_reports',
        component: SupplierComponent,
        name: 'supplier_reports',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 1){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]